import useProgramEnums from './useProgramEnums'
import {useVIP} from '../../hook'
import {useUpdateVIPProgram} from '../../context/useMutation'
import {useIntl} from 'react-intl'
import {toast} from 'react-toastify'
import {Modal} from 'react-bootstrap'
import {useState} from 'react'

export default function ProgramBody({
  loading,
  isProgress,
  refetch,
}: {
  loading: boolean
  isProgress: boolean
  refetch: () => void
}) {
  const intl = useIntl()
  const sections = useProgramEnums()
  const {program, prevProgram} = useVIP()
  const {mutateAsync, isLoading} = useUpdateVIPProgram()

  const [show, setShow] = useState(false)

  const onSubmit = async () => {
    if (!program) return

    if (
      !program.startDate ||
      !program.storeID ||
      !program.entryMethodType ||
      !program.expirationType ||
      !program.status
    ) {
      toast.error(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'}))
      return
    }

    await mutateAsync({values: program})
    refetch()
  }

  const controlForChangeProgram = () => {
    if (!program || !prevProgram)
      return {
        startDate: false,
        entryMethodType: false,
        expirationType: false,
        status: false,
        any: false,
      }

    return {
      startDate: program.startDate !== prevProgram.startDate,
      entryMethodType: program.entryMethodType !== prevProgram.entryMethodType,
      expirationType: program.expirationType !== prevProgram.expirationType,
      status: program.status !== prevProgram.status,
      any:
        program.startDate !== prevProgram.startDate ||
        program.entryMethodType !== prevProgram.entryMethodType ||
        program.expirationType !== prevProgram.expirationType ||
        program.status !== prevProgram.status,
    }
  }

  return (
    <>
      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{intl.formatMessage({id: 'VIP.PROGRAM.SURE'})}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {controlForChangeProgram().any ? (
            <>
              <p>{intl.formatMessage({id: 'VIP.PROGRAM.SURE.DESC'})}</p>
              <p>{intl.formatMessage({id: 'VIP.PROGRAM.CHANGE'})}</p>

              <ul className='mt-4'>
                {controlForChangeProgram().startDate && (
                  <li>{intl.formatMessage({id: 'VIP.PROGRAM.CHANGE.START_DATE'})}</li>
                )}
                {controlForChangeProgram().entryMethodType && (
                  <li>{intl.formatMessage({id: 'VIP.PROGRAM.CHANGE.ENTRY_METHOD'})}</li>
                )}
                {controlForChangeProgram().expirationType && (
                  <li>{intl.formatMessage({id: 'VIP.PROGRAM.CHANGE.EXPIRATION_TYPE'})}</li>
                )}
                {controlForChangeProgram().status && (
                  <li>{intl.formatMessage({id: 'VIP.PROGRAM.CHANGE.STATUS'})}</li>
                )}
              </ul>
            </>
          ) : (
            <>
              <p>{intl.formatMessage({id: 'VIP.PROGRAM.NO_CHANGE'})}</p>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button className='btn btn-danger' onClick={() => setShow(false)}>
            {intl.formatMessage({id: 'GLOBAL.BUTTON.CANCEL'})}
          </button>
          <button
            className='btn btn-primary'
            disabled={isLoading || isProgress || !controlForChangeProgram().any}
            onClick={async () => {
              onSubmit()
              setShow(false)
            }}
          >
            {intl.formatMessage({id: 'GLOBAL.BUTTON.UPDATE'})}
          </button>
        </Modal.Footer>
      </Modal>
      <div className='card-boy'>
        {sections.map((section, index) => {
          return (
            <div key={index}>
              <div className='card-header border-0'>
                <div className='card-title d-flex flex-column'>
                  <div className='d-flex align-items-center position-relative my-1'>
                    {section.title}
                  </div>
                  <span className=' fs-6 '>{section.subtitle}</span>
                </div>
              </div>

              <div className='card-body'>
                <div className='row'>
                  <div className='col-md-6 d-flex align-items-center gap-3'>
                    {section?.description && <span className='fs-6'>{section?.description}</span>}
                    <div className='d-flex flex-column gap-3'>
                      {section.inputs.map((input, index) => {
                        return (
                          <div key={index}>
                            {Object.keys(input)?.includes('render') ? (
                              input.render(isProgress)
                            ) : (
                              <div className='form-check form-check-custom form-check-solid'>
                                <input
                                  className='form-check-input'
                                  type='radio'
                                  name={section.key}
                                  id={input.key}
                                  value={input.value}
                                  checked={input.isChecked}
                                  onChange={input.onChange}
                                  disabled={isProgress}
                                />
                                <label
                                  className='form-check-label d-flex flex-column'
                                  htmlFor={input.key}
                                >
                                  <span className='fw-bold text-black'> {input.label}</span>
                                  {input.description && (
                                    <span className='fs-6 '>{input.description}</span>
                                  )}
                                </label>
                              </div>
                            )}
                          </div>
                        )
                      })}
                    </div>
                  </div>
                  {section.footer && (
                    <span className='fs-6 mt-5' style={{fontStyle: 'italic'}}>
                      {section.footer}
                    </span>
                  )}
                </div>
              </div>
              {index < sections.length - 1 && (
                <div
                  className='separator my-3'
                  style={{
                    borderBottom: '1px solid #e0e0e0',
                  }}
                ></div>
              )}
            </div>
          )
        })}
      </div>
      <div className='card-footer'>
        <button
          className='btn btn-primary'
          disabled={isLoading || isProgress}
          onClick={() => {
            setShow(true)
          }}
        >
          <span className='indicator-label'>
            {isLoading
              ? intl.formatMessage({id: 'LOADING'})
              : intl.formatMessage({id: 'GLOBAL.BUTTON.UPDATE.SCHEDULED'})}
          </span>
        </button>
      </div>
    </>
  )
}
